import { fetchFastApi } from "../../api/fastapi";
import { useHookCacheQuery } from "../../lib/hookCache";
import { SourceRow, sourceRowSchema } from "../../models/audit/auditSession";

/**
 * Hook for the new Phase 2 single-source-row endpoint:
 * `GET /controls/v2/procedure-session/{psId}/source-rows/{srId}`.
 *
 * Returns the fully-hydrated row (with `check_results`,
 * `attribute_test_results`, etc.). Shipped now so Phase 3 work-paper
 * components can begin per-row hydration without further hook plumbing.
 */
export function useSourceRow(
  procedureSessionId: string | undefined,
  sourceRowId: string | undefined,
) {
  return useHookCacheQuery<SourceRow>({
    key: [
      "procedure-session",
      procedureSessionId ?? "",
      "source-rows",
      sourceRowId ?? "",
    ],
    fetcher: async () => {
      const response = await fetchFastApi({
        method: "GET",
        path: `/controls/v2/procedure-session/${procedureSessionId}/source-rows/${sourceRowId}`,
      });
      return sourceRowSchema.parse(response);
    },
    enabled: !!procedureSessionId && !!sourceRowId,
  });
}
